function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
var wrapper = function wrapper(component) {
  // 销毁组件
  var destoryDialog = function destoryDialog(element) {
    var unmountResult = ReactDOM.unmountComponentAtNode(element);
    if (unmountResult && element.parentNode) {
      setTimeout(function () {
        element.parentNode.removeChild(element);
      }, 300);
    }
  };
  // 渲染组件
  // eslint-disable-next-line @typescript-eslint/no-shadow
  var render = function render(_ref) {
    var element = _ref.element,
      component = _ref.component,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config;
    var comInstance = /*#__PURE__*/React.createElement(ConfigProvider, {
      locale: zhCN
    }, /*#__PURE__*/React.createElement(component, _objectSpread(_objectSpread({}, config), {}, {
      key: 'div',
      closeDialog: function closeDialog() {
        destoryDialog(element);
      },
      visible: true
    })));
    ReactDOM.render(comInstance, element);
  };
  return function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // 挂载div
    var element = document.createElement('div');
    render({
      element: element,
      component: component,
      config: config
    });
    document.getElementsByTagName('body')[0].appendChild(element);
  };
};
export default wrapper;